import { getMomentDate } from "../utils/commonUtils";

export default class InventorySalePlanMode {
  constructor(data = {}) {
    this.setData(data);
  }

  setData(data = {}) {
    this.productCode = data.productCode || undefined;
    this.isPlanSale = data.isPlanSale;
  }

  export() {
    return {
      productCode: this.productCode,
      isPlanSale: this.isPlanSale,
    };
  }
}
